import { types } from './actions';

const DEFAULT_NEXT_CURSOR = { first: null, cursorPosition: null };
const DEFAULT_PREV_CURSOR = { last: null, cursorPosition: null };
const DEFAULT_PAGE_SIZE = 20;

const initialState = {
  districtId: null,
  departmentId: null,
  jobTicketNumber: '',
  operatorId: null,
  leaseId: null,
  sorted: [{
    id: 'date',
    desc: true,
    order: 1,
  }],

  /* NOTE: Sets the number of rows shown in the react table */
  pageSize: DEFAULT_PAGE_SIZE,

  /* NOTE: default values to fire off query */
  nextCursorObject: { first: DEFAULT_PAGE_SIZE, cursorPosition: null },
  prevCursorObject: DEFAULT_PREV_CURSOR,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_DEPARTMENT_ID: {
      const { departmentId } = action;
      const { pageSize } = state;
      return {
        ...state,
        departmentId,
        nextCursorObject: { first: pageSize, cursorPosition: null },
        prevCursorObject: DEFAULT_PREV_CURSOR,
      };
    }

    case types.SET_DISTRICT_ID: {
      const { districtId } = action;
      const { pageSize } = state;
      return {
        ...state,
        districtId,
        nextCursorObject: { first: pageSize, cursorPosition: null },
        prevCursorObject: DEFAULT_PREV_CURSOR,
      };
    }


    case types.SET_LEASE_ID: {
      const { leaseId } = action;
      const { pageSize } = state;
      return {
        ...state,
        leaseId,
        nextCursorObject: { first: pageSize, cursorPosition: null },
        prevCursorObject: DEFAULT_PREV_CURSOR,
      };
    }


    case types.SET_OPERATOR_ID: {
      const { operatorId } = action;
      const { pageSize } = state;
      return {
        ...state,
        operatorId,
        leaseId: null,
        nextCursorObject: { first: pageSize, cursorPosition: null },
        prevCursorObject: DEFAULT_PREV_CURSOR,
      };
    }

    case types.SET_JOB_TICKET_NUMBER: {
      const { jobTicketNumber } = action;
      const { pageSize } = state;
      return {
        ...state,
        jobTicketNumber,
        nextCursorObject: { first: pageSize, cursorPosition: null },
        prevCursorObject: DEFAULT_PREV_CURSOR,
      };
    }

    case types.SET_FILTERING_VALUES: {
      console.log('action', action);
      const { jobTicketNumber, operatorId, leaseId, districtId, departmentId } = action;
      const { pageSize } = state;
      return {
        ...state,
        jobTicketNumber,
        operatorId,
        leaseId,
        districtId,
        departmentId,
        nextCursorObject: { first: pageSize, cursorPosition: null },
        prevCursorObject: DEFAULT_PREV_CURSOR,
      };
    }

    case types.SET_TABLE_ORDER: {
      const { sorted } = action;
      return {
        ...state,
        sorted,
      };
    }

    case types.SET_PAGE_SIZE: {
      const { pageSize } = action;

      return {
        ...state,
        pageSize,
        nextCursorObject: { first: pageSize, cursorPosition: null },
        prevCursorObject: DEFAULT_PREV_CURSOR,
      };
    }

    case types.SET_PREV_CURSOR: {
      const { prevCursor } = action;
      const { pageSize } = state;
      return {
        ...state,
        prevCursorObject: { last: pageSize, cursorPosition: prevCursor },
        nextCursorObject: DEFAULT_NEXT_CURSOR,
      };
    }

    case types.SET_NEXT_CURSOR: {
      const { nextCursor } = action;
      const { pageSize } = state;
      return {
        ...state,
        nextCursorObject: { first: pageSize, cursorPosition: nextCursor },
        prevCursorObject: DEFAULT_PREV_CURSOR,
      };
    }

    default:
      return state;
  }
};

export default reducer;
